<template>
  <print-receipt-frame
    ref="printreceipt"
    :is-preview="true"
  />
</template>

<script>
import PrintReceiptFrame from '@/components/PrintReceiptFrame'
export default {
  components: {
    'print-receipt-frame': PrintReceiptFrame
  },
  mounted () {
    this.$refs.printreceipt.getReceiptData()
  }
}
</script>

<style>

</style>
